import React, { useEffect } from "react";
import { MDBBtn, MDBContainer, MDBRow } from "mdbreact";
import UseGaTracker from "../../useGaTracker";
export default function ThankYou(props) {
  UseGaTracker()
  useEffect(() => {
    try {
      if (window.gtag) {
        window.gtag("event", "conversion", {
          send_to: "AW-617997219/0o6lCM2fy98BEKPH16YC",
        });
      }
    } catch (e) {}
  });

  return (
    <MDBContainer>
      <MDBRow center></MDBRow>
      <MDBRow center className="d-flex flex-column align-items-center">
        {/* {props.isLoader ? (
          <div className="SpinnerContainer">
            <div className="spinner-border text-info" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : null} */}
        <>
          <h2 className="text-center pt-4 sm-thankyou">
            Thank You, We've received your information and are in the process of
            preparing your PassPort Documents you will receive an email with
            your documents alongside your login details.
          </h2>
          <a href="https://passportdocpros.com/">
            <MDBBtn
              color="primary"
              rounded
              type="button"
              className="z-depth-1a"
            >
              Go Home
            </MDBBtn>
          </a>
        </>
      </MDBRow>
    </MDBContainer>
  );
}
